import React from 'react';
import ReactDOM from 'react-dom/client';
import 'react-phone-number-input/style.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// React 18 "createRoot" approach
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// optional performance metrics
reportWebVitals();